module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_04.ac28d62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_04.png
// module id = N461
// module chunks = 10